export const ClaimPremiums = ['O', 'N', 'G'];
export var ReserveType;
(function (ReserveType) {
    ReserveType["BODILY_INSURY"] = "bodilyInsury";
    ReserveType["INDEMNITY"] = "indemnity";
    ReserveType["ANNUITY"] = "annuity";
    ReserveType["OTHER_ANNUITY"] = "otherAnnuity";
    ReserveType["FINANCIAL_LOSS"] = "financialLoss";
})(ReserveType || (ReserveType = {}));
export const riskGroups = [
    '01.0_AH_BASIC',
    '01.0_AH_FOREIGNPLUS',
    '02.1_VK_BASIC',
    '02.1_VK_GAP',
    '02.1_VK_GROSSNEGL',
    '02.1_VK_ITEMPP',
    '02.2_TK_GAP',
    '02.2_TK_GROSSNEGL',
    '02.2_TK_ITEMPP',
    '02.2_TK_TKMP',
    '02.2_TK_TKOP',
    '03.0_IU_ACCIDENTCOSTS',
    '03.0_IU_CHILDBENEFIT',
    '03.0_IU_DAYMONEY',
    '03.0_IU_DEATH',
    '03.0_IU_PERMDISABILITY',
    '04.0_AS_BASIC',
];
